// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { vmiBinsImportModalStyles } from "@insite/content-library/Components/VmiBinsImportModal";
import { fontConfig } from "@vanmeter/XDL/constants";
import { createLinkIconStyles, modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

vmiBinsImportModalStyles.buttonsGridItem = {
    ...modalButtonsActionStyles.buttonsGridItem,
};

vmiBinsImportModalStyles.importButton = {
    ...modalButtonsActionStyles.submitButton,
};

vmiBinsImportModalStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

vmiBinsImportModalStyles.templateLink = {
    ...createLinkIconStyles({
        icon: "Download",
        sizeVariant: "small",
    }),
};

vmiBinsImportModalStyles.firstRowOptionCheckbox = {
    css: css`
        margin: 8px 0;
        display: block;
    `,
};

vmiBinsImportModalStyles.instructionText = {
    ...fontConfig.smallSingleLine,
    css: css`
        margin-bottom: 12px;
    `,
};

vmiBinsImportModalStyles.fileUploader = {
    mergeCss: true,
    buttonProps: {
        variant: "secondary",
    },
};
